export class ClientAccess {
    scriptSystemFunctions: string[] = [];
}
